export type GoalOption =
  | ''
  | 'travel'
  | 'cash-back'
  | 'balance-transfer'
  | 'saving-interest'
  | 'building-credit';

export type SelectOption = {
  value: GoalOption;
  label: string;
  disabled?: boolean;
};

export const DEFAULT_LABEL = 'I need a credit card for...';

export const TRK_LOCATION = {
  JumpPageHero: 'cf_landing_hero_cta',
  JumpPageBottom: 'cf_landing_bottom_cta',
} as const;

export const options: SelectOption[] = [
  { value: 'travel', label: 'I want travel rewards and perks' },
  { value: 'cash-back', label: 'I want to earn cash back on purchases' },
  { value: 'balance-transfer', label: 'I want to pay down debt' },
  { value: 'saving-interest', label: 'I want to make a big purchase' },
  { value: 'building-credit', label: 'I want to build my credit' },
];

export const optionsWithDefault: SelectOption[] = [
  { value: '', label: DEFAULT_LABEL, disabled: true },
  ...options,
];

export const HAND_IMG =
  'https://www.nerdwallet.com/cdn/performance-marketing-client/hand-with-multiple-credit-cards%201.svg';

export const youDeserveBenefits = [
  {
    title: 'It won’t affect your credit score',
    content: 'There’s no hard credit check required to see your results.',
  },
  {
    title: 'See smart recommendations in minutes',
    content: 'We only ask questions that are essential. No contact info required.',
  },
  {
    title: 'Tap into objective ratings',
    content: 'See the pros and cons of each credit card we recommend.',
  },
];

export const howItWorksSteps = [
  {
    heading: 'Tell us what you’re looking for',
    alt: 'Answer a few questions',
    subHeading:
      'To help you find smart options, we need to ask a few basic questions. We won’t ask you to sign up for an account or send marketing emails.',
    imgSrc: 'https://www.nerdwallet.com/cdn/performance-marketing-client/how-it-works-2.svg',
  },
  {
    heading: 'We’ll crunch the numbers',
    alt: 'Preparing your recommendations',
    subHeading:
      'Our proprietary system analyzes credit cards across a wide variety of providers, allowing us to find smart picks for your situation.',
    imgSrc: 'https://www.nerdwallet.com/cdn/performance-marketing-client/how-it-works-3.svg',
  },
  {
    heading: 'Compare recommendations',
    alt: 'Your recommendations',
    subHeading:
      'We’ll help you learn more about your personalized recommendations, and you can apply for cards immediately.',
    imgSrc: 'https://www.nerdwallet.com/cdn/performance-marketing-client/how-it-works-1.svg',
  },
];

export const companyLogos = [
  {
    id: 'chase',
    name: 'Chase',
    imgUrl: 'https://www.nerdwallet.com/cdn/performance-marketing-client/company-logos/chase.png',
  },
  {
    id: 'capitalOne',
    name: 'Capital One',
    imgUrl:
      'https://www.nerdwallet.com/cdn/performance-marketing-client/company-logos/capital-one.png',
  },
  {
    id: 'americanExpress',
    name: 'American Express',
    imgUrl:
      'https://www.nerdwallet.com/cdn/performance-marketing-client/company-logos/american-express.png',
  },
  {
    id: 'bankOfAmerica',
    name: 'Bank of America',
    imgUrl:
      'https://www.nerdwallet.com/cdn/performance-marketing-client/company-logos/bank-of-america.png',
  },
  {
    id: 'citi',
    name: 'Citi',
    imgUrl:
      'https://www.nerdwallet.com/cdn/performance-marketing-client/company-logos/citibank.png',
  },
  {
    id: 'wellsFargo',
    name: 'Wells Fargo',
    imgUrl:
      'https://www.nerdwallet.com/cdn/performance-marketing-client/company-logos/wells-fargo.png',
  },
];

export const dataMetrics = [
  {
    title: '2.8M+',
    body: 'Customers per month shop our credit cards marketplace.' as const,
  },
  {
    title: '1,000+',
    body: 'Hours spent by experts reviewing cards.' as const,
  },
  {
    title: '2+ Minutes',
    body: 'questionnaire' as const,
  },
];
